import Calendar from 'react-calendar/dist/entry.nostyle'
import {DateTime} from 'luxon';

import styles from './DateSelect.module.scss'

export default ({ onDateChange, selectedDate }) => {
  const minDate = new Date();
  let maxDate = new Date();
  maxDate.setMonth(maxDate.getMonth() + 2);

  return (
    <Calendar className={styles.calendar}
      calendarType="US"
      prev2Label={null}
      next2Label={null}
      minDetail="month"
      value={selectedDate && DateTime.fromISO(selectedDate).toJSDate()}
      maxDate={maxDate}
      minDate={minDate}
      onClickDay={date => onDateChange(DateTime.fromJSDate(date).toISODate())}
    />
  )
}
